import { type FC } from 'react';
import {
  AnimatePresence,
  motion,
  type Transition,
  type Variants,
} from 'framer-motion';

import { useAppSelector } from '@/redux/store';

import { BoxReward } from '../BoxReward/BoxReward';
import { MainDiceGameButton } from '../Buttons/MainDiceGameButton';
import { CardsBoard } from '../CardsBoard/CardsBoard';
import { DiceBoard } from '../DiceBoard/DiceBoard';

const Board: FC = () => {
  const activeBoard = useAppSelector((state) => state.diceGame.activeBoard);

  const key = activeBoard === 'box' ? 'box' : 'main';

  const boxTransition: Transition = {
    type: 'spring',
    stiffness: 600,
    mass: 1,
    damping: 35,
  };

  const variants: Variants = {
    hidden: {
      opacity: 0,
      position: 'absolute',
      transition: boxTransition,
    },
    visible: {
      opacity: 1,
      transition: boxTransition,
    },
  };

  return (
    <AnimatePresence>
      <motion.div
        key={key}
        variants={variants}
        initial={{ opacity: 0 }}
        animate="visible"
        exit="hidden"
        className="w-full relative flex-1"
      >
        {activeBoard === 'box' ? (
          <BoxReward />
        ) : (
          <motion.div
            initial={activeBoard === 'cards' ? { x: '-50%' } : { x: 0 }}
            animate={activeBoard === 'cards' ? { x: '-50%' } : { x: 0 }}
            transition={boxTransition}
            className="absolute top-0 left-0 w-[200%] flex h-full"
          >
            <DiceBoard />
            <AnimatePresence>
              {activeBoard === 'cards' && <CardsBoard />}
            </AnimatePresence>
          </motion.div>
        )}
      </motion.div>
      <MainDiceGameButton />
    </AnimatePresence>
  );
};

export { Board };
